import KeyboardFocusable from '../KeyboardFocusable';

import Controls from './Controls';

export default class LocalVideo extends Controls {
    namespace = 'localVideo';
    constructor() {
        super();
        this.items = [];
        this.collectElements();
    }

    collectElements() {
        const el = document.getElementById('localVideoContainer');

        this._items.push(
            new KeyboardFocusable(el)
        );
    }

    isPossibleUp() {
        return false;
    }

    isPossibleDown() {
        return false;
    }

}
